import { render } from "./MyInputText.vue?vue&type=template&id=3c3bfb50"
import script from "./MyInputText.vue?vue&type=script&lang=js"
export * from "./MyInputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__